var map = {
	"./casino-bg.embed.svg": 597326,
	"./casino-cs.embed.svg": 185381,
	"./casino-da.embed.svg": 857610,
	"./casino-de.embed.svg": 291614,
	"./casino-el.embed.svg": 589816,
	"./casino-en.embed.svg": 307666,
	"./casino-es.embed.svg": 316931,
	"./casino-et.embed.svg": 171728,
	"./casino-fi.embed.svg": 11620,
	"./casino-fr.embed.svg": 465147,
	"./casino-hr.embed.svg": 100097,
	"./casino-hu.embed.svg": 974450,
	"./casino-is.embed.svg": 411775,
	"./casino-it.embed.svg": 132964,
	"./casino-ja.embed.svg": 527656,
	"./casino-lt.embed.svg": 73723,
	"./casino-lv.embed.svg": 983697,
	"./casino-nl.embed.svg": 194429,
	"./casino-no.embed.svg": 423346,
	"./casino-pl.embed.svg": 354439,
	"./casino-pt-BR.embed.svg": 611042,
	"./casino-pt.embed.svg": 16767,
	"./casino-ro.embed.svg": 915382,
	"./casino-ru.embed.svg": 972676,
	"./casino-sl.embed.svg": 576806,
	"./casino-sv.embed.svg": 188116,
	"./casino-uk.embed.svg": 238619,
	"./casino-zh-CN.embed.svg": 375183,
	"./casino-zh-TW.embed.svg": 795563,
	"./poker-bg.embed.svg": 963188,
	"./poker-ca.embed.svg": 871881,
	"./poker-cs.embed.svg": 392067,
	"./poker-da.embed.svg": 719968,
	"./poker-de.embed.svg": 890468,
	"./poker-el.embed.svg": 168086,
	"./poker-en.embed.svg": 6796,
	"./poker-es.embed.svg": 14437,
	"./poker-et.embed.svg": 642702,
	"./poker-fi.embed.svg": 406342,
	"./poker-fr.embed.svg": 747353,
	"./poker-hr.embed.svg": 412259,
	"./poker-hu.embed.svg": 952112,
	"./poker-is.embed.svg": 513513,
	"./poker-it.embed.svg": 464922,
	"./poker-ja.embed.svg": 337298,
	"./poker-lt.embed.svg": 821857,
	"./poker-lv.embed.svg": 479307,
	"./poker-nl.embed.svg": 655695,
	"./poker-no.embed.svg": 618032,
	"./poker-pl.embed.svg": 41013,
	"./poker-pt-BR.embed.svg": 734532,
	"./poker-pt.embed.svg": 584573,
	"./poker-ro.embed.svg": 568764,
	"./poker-ru.embed.svg": 657630,
	"./poker-sl.embed.svg": 504840,
	"./poker-sv.embed.svg": 530970,
	"./poker-uk.embed.svg": 135709,
	"./poker-zh-CN.embed.svg": 404797,
	"./poker-zh-TW.embed.svg": 401741,
	"./sports-bg.embed.svg": 643090,
	"./sports-ca.embed.svg": 252987,
	"./sports-cs.embed.svg": 248993,
	"./sports-da.embed.svg": 260526,
	"./sports-de.embed.svg": 410202,
	"./sports-el.embed.svg": 390324,
	"./sports-en.embed.svg": 690782,
	"./sports-es.embed.svg": 658935,
	"./sports-et.embed.svg": 959164,
	"./sports-fi.embed.svg": 895800,
	"./sports-fr.embed.svg": 586031,
	"./sports-hr.embed.svg": 213069,
	"./sports-hu.embed.svg": 146134,
	"./sports-is.embed.svg": 200651,
	"./sports-it.embed.svg": 499000,
	"./sports-ja.embed.svg": 92612,
	"./sports-lt.embed.svg": 780279,
	"./sports-lv.embed.svg": 890365,
	"./sports-nl.embed.svg": 134009,
	"./sports-no.embed.svg": 628286,
	"./sports-pl.embed.svg": 148459,
	"./sports-pt-BR.embed.svg": 747894,
	"./sports-pt.embed.svg": 205219,
	"./sports-ro.embed.svg": 11274,
	"./sports-ru.embed.svg": 213464,
	"./sports-sl.embed.svg": 734522,
	"./sports-sv.embed.svg": 320808,
	"./sports-uk.embed.svg": 193823,
	"./sports-zh-CN.embed.svg": 906611,
	"./sports-zh-TW.embed.svg": 397943,
	"swf-core/assets/localized/casino-bg.embed.svg": 597326,
	"swf-core/assets/localized/casino-cs.embed.svg": 185381,
	"swf-core/assets/localized/casino-da.embed.svg": 857610,
	"swf-core/assets/localized/casino-de.embed.svg": 291614,
	"swf-core/assets/localized/casino-el.embed.svg": 589816,
	"swf-core/assets/localized/casino-en.embed.svg": 307666,
	"swf-core/assets/localized/casino-es.embed.svg": 316931,
	"swf-core/assets/localized/casino-et.embed.svg": 171728,
	"swf-core/assets/localized/casino-fi.embed.svg": 11620,
	"swf-core/assets/localized/casino-fr.embed.svg": 465147,
	"swf-core/assets/localized/casino-hr.embed.svg": 100097,
	"swf-core/assets/localized/casino-hu.embed.svg": 974450,
	"swf-core/assets/localized/casino-is.embed.svg": 411775,
	"swf-core/assets/localized/casino-it.embed.svg": 132964,
	"swf-core/assets/localized/casino-ja.embed.svg": 527656,
	"swf-core/assets/localized/casino-lt.embed.svg": 73723,
	"swf-core/assets/localized/casino-lv.embed.svg": 983697,
	"swf-core/assets/localized/casino-nl.embed.svg": 194429,
	"swf-core/assets/localized/casino-no.embed.svg": 423346,
	"swf-core/assets/localized/casino-pl.embed.svg": 354439,
	"swf-core/assets/localized/casino-pt-BR.embed.svg": 611042,
	"swf-core/assets/localized/casino-pt.embed.svg": 16767,
	"swf-core/assets/localized/casino-ro.embed.svg": 915382,
	"swf-core/assets/localized/casino-ru.embed.svg": 972676,
	"swf-core/assets/localized/casino-sl.embed.svg": 576806,
	"swf-core/assets/localized/casino-sv.embed.svg": 188116,
	"swf-core/assets/localized/casino-uk.embed.svg": 238619,
	"swf-core/assets/localized/casino-zh-CN.embed.svg": 375183,
	"swf-core/assets/localized/casino-zh-TW.embed.svg": 795563,
	"swf-core/assets/localized/poker-bg.embed.svg": 963188,
	"swf-core/assets/localized/poker-ca.embed.svg": 871881,
	"swf-core/assets/localized/poker-cs.embed.svg": 392067,
	"swf-core/assets/localized/poker-da.embed.svg": 719968,
	"swf-core/assets/localized/poker-de.embed.svg": 890468,
	"swf-core/assets/localized/poker-el.embed.svg": 168086,
	"swf-core/assets/localized/poker-en.embed.svg": 6796,
	"swf-core/assets/localized/poker-es.embed.svg": 14437,
	"swf-core/assets/localized/poker-et.embed.svg": 642702,
	"swf-core/assets/localized/poker-fi.embed.svg": 406342,
	"swf-core/assets/localized/poker-fr.embed.svg": 747353,
	"swf-core/assets/localized/poker-hr.embed.svg": 412259,
	"swf-core/assets/localized/poker-hu.embed.svg": 952112,
	"swf-core/assets/localized/poker-is.embed.svg": 513513,
	"swf-core/assets/localized/poker-it.embed.svg": 464922,
	"swf-core/assets/localized/poker-ja.embed.svg": 337298,
	"swf-core/assets/localized/poker-lt.embed.svg": 821857,
	"swf-core/assets/localized/poker-lv.embed.svg": 479307,
	"swf-core/assets/localized/poker-nl.embed.svg": 655695,
	"swf-core/assets/localized/poker-no.embed.svg": 618032,
	"swf-core/assets/localized/poker-pl.embed.svg": 41013,
	"swf-core/assets/localized/poker-pt-BR.embed.svg": 734532,
	"swf-core/assets/localized/poker-pt.embed.svg": 584573,
	"swf-core/assets/localized/poker-ro.embed.svg": 568764,
	"swf-core/assets/localized/poker-ru.embed.svg": 657630,
	"swf-core/assets/localized/poker-sl.embed.svg": 504840,
	"swf-core/assets/localized/poker-sv.embed.svg": 530970,
	"swf-core/assets/localized/poker-uk.embed.svg": 135709,
	"swf-core/assets/localized/poker-zh-CN.embed.svg": 404797,
	"swf-core/assets/localized/poker-zh-TW.embed.svg": 401741,
	"swf-core/assets/localized/sports-bg.embed.svg": 643090,
	"swf-core/assets/localized/sports-ca.embed.svg": 252987,
	"swf-core/assets/localized/sports-cs.embed.svg": 248993,
	"swf-core/assets/localized/sports-da.embed.svg": 260526,
	"swf-core/assets/localized/sports-de.embed.svg": 410202,
	"swf-core/assets/localized/sports-el.embed.svg": 390324,
	"swf-core/assets/localized/sports-en.embed.svg": 690782,
	"swf-core/assets/localized/sports-es.embed.svg": 658935,
	"swf-core/assets/localized/sports-et.embed.svg": 959164,
	"swf-core/assets/localized/sports-fi.embed.svg": 895800,
	"swf-core/assets/localized/sports-fr.embed.svg": 586031,
	"swf-core/assets/localized/sports-hr.embed.svg": 213069,
	"swf-core/assets/localized/sports-hu.embed.svg": 146134,
	"swf-core/assets/localized/sports-is.embed.svg": 200651,
	"swf-core/assets/localized/sports-it.embed.svg": 499000,
	"swf-core/assets/localized/sports-ja.embed.svg": 92612,
	"swf-core/assets/localized/sports-lt.embed.svg": 780279,
	"swf-core/assets/localized/sports-lv.embed.svg": 890365,
	"swf-core/assets/localized/sports-nl.embed.svg": 134009,
	"swf-core/assets/localized/sports-no.embed.svg": 628286,
	"swf-core/assets/localized/sports-pl.embed.svg": 148459,
	"swf-core/assets/localized/sports-pt-BR.embed.svg": 747894,
	"swf-core/assets/localized/sports-pt.embed.svg": 205219,
	"swf-core/assets/localized/sports-ro.embed.svg": 11274,
	"swf-core/assets/localized/sports-ru.embed.svg": 213464,
	"swf-core/assets/localized/sports-sl.embed.svg": 734522,
	"swf-core/assets/localized/sports-sv.embed.svg": 320808,
	"swf-core/assets/localized/sports-uk.embed.svg": 193823,
	"swf-core/assets/localized/sports-zh-CN.embed.svg": 906611,
	"swf-core/assets/localized/sports-zh-TW.embed.svg": 397943
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 372988;
module.exports = webpackAsyncContext;